import type { PaneItemProps } from '.';
import { type FC } from 'react';
import { cn } from '@/app/_shared/utils/tw-cn';

export const BottomArea: FC<PaneItemProps> = ({ type, title, product, startDate, startTime, notificationMessage }) => {
  const { priceTypeCode, discountRate, price } = product || {};
  const isBasicType = priceTypeCode === 'BASIC';
  const showBottomArea = type === 'PREVIEW' || !!product;

  const startSoon = type === 'PREVIEW' && !!notificationMessage;
  const BeforeStart = (
    <>
      <div>
        <span className="mr-4 typography-subtitle-16-bold">{startDate}</span>
        <span className="typography-subtitle-16-regular">{startTime}</span>
      </div>
      {!!notificationMessage && <span className="typography-body-14-regular">{notificationMessage}</span>}
    </>
  );

  const ProductInfo = (
    <>
      <span className="w-full overflow-hidden typography-body-14-regular-line-clamp-1">{product?.title}</span>
      {priceTypeCode !== 'HIDE' && (
        <div className="flex w-full items-center">
          {!!isBasicType && !!discountRate && (
            <span className="mr-4 text-text-accent-medium typography-subtitle-16-regular">{discountRate}%</span>
          )}
          <span className="text-text-neutral-main typography-subtitle-16-bold">{price}</span>
          {!!isBasicType && <span className="flex-shrink-0 text-text-neutral-main typography-body-13-bold">원~</span>}
        </div>
      )}
    </>
  );

  return (
    <div className="absolute bottom-8 left-8 right-8 z-[1] will-change-[opacity]">
      <div className="mx-8 text-static-white typography-subtitle-16-bold-multiline-line-clamp-2">{title}</div>
      {!!showBottomArea && (
        <div
          className={cn(
            'mt-16 flex h-60 flex-col items-center justify-center gap-4 rounded-8 bg-static-white px-16 text-text-neutral-main',
            type !== 'PREVIEW' && 'items-start',
            startSoon && 'bg-fill-primary-weak text-text-accent-medium',
          )}>
          {type === 'PREVIEW' ? BeforeStart : ProductInfo}
        </div>
      )}
    </div>
  );
};
